import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  Card,
  CardContent,
  makeStyles,
  Typography,
  Paper,
  Grid,
  TextField,
  Button,
  InputAdornment,
  IconButton,
  Divider,
} from "@material-ui/core";
import AdminBannerImage from "../images/LoginpageImage/clientadminbackground.png";
import MobileBackgroundImage from "../images/LoginpageImage/clientmobile.png";
import OtpInput from "react18-input-otp";
import { useNavigate, Link, useParams } from "react-router-dom";
import { encryptData } from "../../crypto";

const useStyles = makeStyles((theme) => ({
  card: {
    width: "100vw",
    height: "100vh",
    background: `url(${AdminBannerImage}) center/cover no-repeat`,
    margin: 0,
    display: "flex",
    position: "relative",
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "rgba(225, 225, 225, 1)",
      borderWidth: "1px",
    },
    "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: "rgba(225, 225, 225, 1)",
    },
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      background: `url(${MobileBackgroundImage}) center/cover no-repeat`,
      backgroundSize: "116% 107%",
    },
  },
  backgroundContainer: {
    flex: 1,
    position: "relative",
  },
  textContainer: {
    position: "absolute",
    top: "10%",
    left: "145%",
    transform: "translate(-50%, -50%)",
    textAlign: "center",
    color: "white",
    whiteSpace: "nowrap",
    [theme.breakpoints.down("sm")]: {
      position: "absolute",
      top: "13%",
      left: "50%",
      transform: "translate(-50%, -50%)",
    },
  },
  heading: {
    fontFamily: "Plus Jakarta Sans",
    fontWeight: "800",
    fontSize: "38px",
    color: "rgba(255, 255, 255, 1)",
    [theme.breakpoints.down("sm")]: {
      fontSize: "28px",
    },
  },
  Subheading: {
    fontFamily: "Plus Jakarta Sans",
    fontWeight: "800",
    fontSize: "22px",
    lineHeight: "40px",
    color: "rgba(255, 205, 71, 1)",
    [theme.breakpoints.down("sm")]: {
      fontSize: "16px",
      lineHeight: "20px",
    },
  },
  content: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    "& .MuiGrid-align-items-xs-center": {
      alignItems: "start",
    },
    "& .MuiGrid-container": {
      width: "86%",
      margin: "0 auto",
    },
  },
  additionalCard: {
    width: "450px",
    height: "530px",
    backgroundColor: "rgba(254, 254, 254, 1)",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
    position: "relative",
    top: "50%",
    left: "-100%",
    transform: "translateY(-50%)",
    [theme.breakpoints.down("sm")]: {
      width: "90%",
      height: "auto",
      minHeight: "auto",
      padding: "20px",
      position: "relative",
      top: "auto",
      left: "auto",
      transform: "none",
    },
  },
  loginWithOtp: {
    fontFamily: "Plus Jakarta Sans",
    alignSelf: "end",
    fontSize: "1rem",
    fontWeight: "500",
    color: "rgba(36, 84, 255, 1)",
    textDecoration: "none",
    [theme.breakpoints.down("sm")]: {
      margin: "2px auto",
    },
  },
  signInText: {
    fontFamily: "Poppins",
    fontSize: "32px",
    color: "rgba(47, 47, 47, 1)",
    fontWeight: "700",
    marginTop: "55px",
    [theme.breakpoints.down("sm")]: {
      fontSize: "25px",
      margin: "0px !important",
      paddingRight: "15px",
    },
  },

  number: {
    fontSize: "small",
    marginTop: "10px",
    fontWeight: "550",
    [theme.breakpoints.down("sm")]: {
      width: "60%",
      margin: "0px !important",
      paddingLeft: "60px",
    },
  },
  verification: {
    fontSize: "small",
    marginTop: "10px",
    fontWeight: "550",
    [theme.breakpoints.down("sm")]: {
      margin: "0px",
      marginTop: "20px",
    },
  },
  code: {
    color: "#2481ce",
    fontWeight: "bold",
    margin: "auto",
    fontSize: "80",
    marginRight: "200px",
    marginTop: "10px",
    [theme.breakpoints.down("sm")]: {
      marginTop: "10px",
      marginRight: "0px",
    },
  },
  button: {
    marginTop: "60px",
    margin: "15px 0",
    width: "100%",
    fontWeight: "700",
    fontSize: "16px",
    FontFamily: "Plus Jakarta Sans",
    padding: "0.5rem",
    textTransform: "none",
    borderRadius: "6px",
    backgroundColor: "#F89E17",
    color: "rgba(255, 255, 255, 1)",
    "&:hover": {
      backgroundColor: "rgba(248, 158, 23, 1)",
    },
    [theme.breakpoints.down("sm")]: {
      textTransform: "uppercase",
      backgroundColor: "#F89E17",
    },
  },
}));

function LoginPage({ onLogin }) {
  const classes = useStyles();
  // const navigate = useNavigate();
  // const [otp, setOtp] = useState("");
  // const handleChange = (enteredOtp) => {
  //   setOtp(enteredOtp);
  // };
  // const numbers = param.a;
  let mql = window.matchMedia("(max-width: 600px)");
  let navigate = useNavigate();
  let param = useParams();
  const [formError, setFormError] = useState({});
  const [isSubmitClicked, setIsSubmitClicked] = useState(false);
  console.log(param.a);
  const number = param.a;
  const [otp, setOtp] = useState("");
  const handleChange = (enteredOtp) => {
    setOtp(enteredOtp);
  };
  const handleSubmit = () => {
    setIsSubmitClicked(true);
    // setFormError(validateForm());
  };
  const [msg, setMsg] = useState("");

  const [pageURL, setPageURL] = useState("");

  const urlParams = new URLSearchParams(pageURL.split("?")[1]);
  const token = urlParams.get("token");
  const userName = urlParams.get("userName");

  useEffect(() => {
    setPageURL(window.location.href);
  }, []);

  useEffect(() => {
    if (token && userName) {
      sessionStorage.setItem("token", token);
      sessionStorage.setItem("userName", userName);

      onLogin();
      navigate("/admin/dashboard");
    }
  }, [token, userName, onLogin, navigate]);

  return (
    <Card className={classes.card}>
      <div className={classes.backgroundContainer}>
        <div className={classes.textContainer}>
          <Typography variant="h3" className={classes.heading}>
            Welcome Back!
          </Typography>
          <Typography variant="h4" className={classes.Subheading}>
            Enter Your Credentials
          </Typography>
        </div>
      </div>
      <CardContent className={classes.content}>
        <Paper className={classes.additionalCard}>
          <Grid
            container
            direction="column"
            alignItems="center"
            className={classes.box1}
          >
            <Typography variant="h4" className={classes.signInText}>
              Enter Your OTP
            </Typography>
            <br />
            <div>
              <Typography className={classes.number}>
                Code has send to your Mobile No+{param.a}
              </Typography>
              <br />
              <OtpInput
                value={otp}
                onChange={handleChange}
                numInputs={4}
                separator={<span></span>}
                inputStyle={{
                  width: !mql.matches ? "3rem" : "3.2rem",
                  height: !mql.matches ? "3rem" : "3.2rem",
                  // margin: !mql.matches ? "0 0.8rem" : "0 0.4rem",
                  fontSize: "2rem",
                  border: "none",
                  fontFamily: "Jost",
                  fontWeight: "600",
                  backgroundColor: "#FAF8FF",
                  borderRadius: "10px",
                  boxShadow: "0px 3px 11px 0px rgba(0, 0, 0, 0.17) inset",
                  margin: "10px 18px 0px 20px",
                }}
              />
              <br />
              <Typography className={classes.verification}>
                Haven't recived The Verification Code ?
              </Typography>
              <Button
                className={classes.code}
                onClick={() => {
                  // console.log("Requesting OTP for email:", email);
                  axios({
                    method: "post",
                    url: `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/auth/resend`,
                    data: {
                      user: {
                        phone: param.a,
                      },
                    },
                  }).then(
                    (response) => {
                      console.log("OTP response:", response.data);
                      // navigate(`/otpscreen/${email}`)
                      // handle the response data as needed
                    },
                    (error) => {
                      console.error(
                        "OTP request failed:",
                        error.response.data.message
                      );
                      // handle the error as needed
                    }
                  );
                }}
              >
                Resend code
              </Button>
              <Button
                className={classes.button}
                onClick={() => {
                  axios({
                    method: "put",
                    url: `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/auth/otp_verify_signin`,
                    data: {
                      user: {
                        phone: param.a,
                        otp: otp,
                      },
                    },
                  }).then(
                    (response) => {
                      console.log(response.data);
                      if (response.data.success === true) {
                        setMsg(response.data.message);
                        const encryptedToken = encryptData(response.data.token);

                        const username = response.data.user.first_name;

                        const encryptedUser = encryptData(username);

                        sessionStorage.setItem("token", encryptedToken);
                        sessionStorage.setItem("userName", encryptedUser);

                        onLogin();
                        navigate("/admin/dashboard");
                      }
                    },
                    (error) => {
                      sessionStorage.clear();
                      setIsSubmitClicked(false);
                      setFormError(error.response.data.message);
                    }
                  );
                }}
              >
                Login
              </Button>
            </div>
          </Grid>
        </Paper>
      </CardContent>
    </Card>
  );
}

export default LoginPage;
